<template>
    <div class="login-base">
        <div class="login-overlay">
            <div class="container">
                <img src="../../assets/images/logo.svg" alt="">
                <div id="title">
                    <slot name="title"></slot>
                </div>
                <form class="form-login">
                    <div class="font-btn-small">email</div>
                    <input type="email" class="font-input" value="max@mustermann.ch">

                    <slot name="password"></slot>

                    <div class="bottom-div">
                        <li type="text" style="padding: 0;" class="font-size-btn btn btn-primary btn-purple"
                                 @click.prevent="submitted">
                            <slot name="btn"></slot>
                        </li>
                    </div>

                </form>
                <slot name="bottom-btn"></slot>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    methods: {
      submitted (e) {
        e.preventDefault()
      }
    }
  }
</script>

<style lang="scss" scoped>
    .login-base {
        height: 100%;
        background-image: url("../../assets/images/bg-login.png");
        background-size: cover;
        .login-overlay {
            height: 100%;
            top: 0;
            right: 0;
            background-image: linear-gradient(rgba(49, 49, 49, 0.2),rgba(0, 0, 0, 1));
            color: white;
        }
    }

    #title {
        height: 76px;
        margin: 48px 0 38px;
        line-height: 380%;
    }

    .container {
        padding: 70px 36px 36px;

        form {
            position: relative;
            height: 245px;
            .font-btn-small {
                text-transform: uppercase;
                padding: 0;
            }
            .bottom-div {
                position: absolute;
                width: 100%;
                bottom: 0;
            }
        }
        .bottom-btn {
            position: fixed;
            width: calc(100% - 72px);
            text-align: center;
            bottom: 62px;
        }
    }

    button {
        padding: 0;
        a {
            padding: 14px;
            display: block;
            height: 100%; width: 100%;
        }
    }
</style>
